import { useState, useEffect } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Stato "modalità lancio" (fee azzerata + Premium incluso). Fonte: backend
// GET /api/settings/launch-mode, con fallback a localStorage e aggiornamento
// live tramite l'evento 'launchModeChanged' emesso dalla dashboard admin.
export function useLaunchMode() {
  const [launchMode, setLaunchMode] = useState(
    () => typeof window !== 'undefined' && localStorage.getItem('rarifex_launch_mode') === 'true'
  );

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const r = await fetch(`${API_URL}/api/settings/launch-mode`);
        if (r.ok && active) {
          const d = await r.json();
          const v = d.launch_mode === true;
          setLaunchMode(v);
          try { localStorage.setItem('rarifex_launch_mode', v ? 'true' : 'false'); } catch { /* noop */ }
        }
      } catch { /* mantiene il fallback localStorage */ }
    })();

    const handler = (e) => setLaunchMode(!!e.detail?.enabled);
    window.addEventListener('launchModeChanged', handler);
    return () => { active = false; window.removeEventListener('launchModeChanged', handler); };
  }, []);

  return launchMode;
}
